import methods from '@/services/methods'

export default {
  whitelistIps () {
    return methods.sendGet('ip_whitelist', null, {unprivilege: 'Settings', noHyptoLoader: true})
  },
  addWhitelistIp (payload) {
    return methods.sendPost('ip_whitelist', payload, {restrictToast: true})
  },
  deleteWhitelistIp (payload) {
    return methods.sendDelete('ip_whitelist', payload)
  }
}
